import { render, staticRenderFns } from "./agp_data.vue?vue&type=template&id=097ed40f&"
import script from "./agp_data.vue?vue&type=script&lang=js&"
export * from "./agp_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports